/* WARP: 存在しない組み合わせのカラーを選択肢から除外する
   - 存在しない組み合わせ（例: つやなし × グロスブラック）→ DOMから削除
   - 実在するが在庫切れ → 残して「- 在庫なし」表記

   なぜ hidden ではなく削除なのか:
   iOS Safari は <option hidden> を無視するため、hidden だとスマホで消えない。
   DOMから出し入れすれば全ブラウザで確実に動く。
   既存のテーマJS（VariantSelects）は改造しない。
*/
(function () {
  var SOLD_OUT_SUFFIX = ' - 在庫なし';
  var SEP = String.fromCharCode(1);

  function getVariants(vs) {
    var s = vs.querySelector('script[type="application/json"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function init(vs) {
    if (vs.__warpHideInit) return;
    var variants = getVariants(vs);
    if (!variants || !variants.length) return;
    var selects = Array.prototype.slice.call(vs.querySelectorAll('select'));
    if (!selects.length) return;
    vs.__warpHideInit = true;

    // 各selectの全選択肢（値のマスター）を保持しておく
    var master = selects.map(function (sel) {
      return Array.prototype.slice.call(sel.options).map(function (o) { return o.value; });
    });

    function matches(idx, value, chosen) {
      return variants.filter(function (v) {
        if (!v || !v.options) return false;
        for (var i = 0; i < idx; i++) {
          if (v.options[i] !== chosen[i]) return false;
        }
        return v.options[idx] === value;
      });
    }

    function refresh() {
      var chosen = selects.map(function (s) { return s.value; });

      selects.forEach(function (sel, idx) {
        var keep = [];
        master[idx].forEach(function (value) {
          var m = matches(idx, value, chosen);
          if (m.length) {
            keep.push({
              value: value,
              available: m.some(function (v) { return v.available; })
            });
          }
        });
        if (!keep.length) return;

        var wanted = keep.some(function (o) { return o.value === sel.value; }) ? sel.value : keep[0].value;

        // 選択肢の面子が変わったときだけ再構築（iOSのピッカー再描画を減らす）
        var currentSig = Array.prototype.slice.call(sel.options).map(function (o) { return o.value; }).join(SEP);
        var keepSig = keep.map(function (o) { return o.value; }).join(SEP);

        if (currentSig !== keepSig) {
          while (sel.firstChild) { sel.removeChild(sel.firstChild); }
          keep.forEach(function (o) {
            var el = document.createElement('option');
            el.value = o.value;
            el.textContent = o.available ? o.value : o.value + SOLD_OUT_SUFFIX;
            sel.appendChild(el);
          });
        }

        sel.value = wanted;
        if (chosen[idx] !== wanted) {
          chosen[idx] = wanted;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    vs.addEventListener('change', function () { setTimeout(refresh, 0); });
    refresh();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('variant-selects')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

/* WARP: 在庫0でも販売継続（＝予約受付）のバリアントは、
   在庫バッジを「在庫なし」ではなく「予約受付中｜8月下旬発送」と表示する。

   判定条件:
     バッジが --empty（＝在庫数0） かつ カートに入れるボタンが有効
   → Shopifyの「在庫切れ時も販売を続ける」がONのときだけ成立する。

   テーマ本体（sections/main-product.liquid）は触らずDOM後処理で対応。
   予約をやめる場合は在庫を1以上に戻すだけでよく、この処理は自動的に無効になる。
   発送時期が変わったら下の LABEL を書き換える。
*/
(function () {
  var LABEL = '予約受付中｜8月下旬発送';
  var EMPTY_CLASS = 'product__inventory-inner--empty';
  var PREORDER_CLASS = 'product__inventory-inner--preorder';
  var STYLE_ID = 'warp-preorder-badge-style';
  var patching = false;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    // テーマ側の配色指定が複数（media / data-scheme）あるため !important で確実に上書きする
    s.textContent =
      '.' + PREORDER_CLASS +
      '{color:#8a4b00 !important;background-color:#ffeccc !important;white-space:nowrap;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function patchOne(inv) {
    var span = inv.querySelector('.product__inventory-inner');
    if (!span) return;
    if (!span.classList.contains(EMPTY_CLASS)) return;

    var scope = inv.closest('.shopify-section') || document;
    var btn = scope.querySelector('button[name="add"].product-form__submit');
    if (!btn || btn.disabled) return;

    span.classList.remove(EMPTY_CLASS);
    span.classList.add(PREORDER_CLASS);
    span.textContent = LABEL;
  }

  function patchAll() {
    if (patching) return;
    patching = true;
    try {
      Array.prototype.slice
        .call(document.querySelectorAll('.product__inventory'))
        .forEach(patchOne);
    } finally {
      setTimeout(function () { patching = false; }, 0);
    }
  }

  function observe(inv) {
    if (inv.__warpPreorderObserved) return;
    inv.__warpPreorderObserved = true;
    // バリアント切替時、テーマJSがこのdivのinnerHTMLを差し替えるので監視する
    new MutationObserver(function () { patchAll(); })
      .observe(inv, { childList: true, subtree: true });
  }

  function boot() {
    injectStyle();
    Array.prototype.slice
      .call(document.querySelectorAll('.product__inventory'))
      .forEach(observe);
    patchAll();
    // カートボタンの状態確定が遅れるケースの保険
    setTimeout(patchAll, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();